import React, { FC } from 'react';
import { Text } from 'react-native';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { font as initialFont } from '@styles/fonts';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';

export interface MachineCellProps
  extends Pick<UseTableColumnsParams, 'textConfig' | 'eventType' | 'C' | 'font'>,
    Pick<EventStatusSubStatusExecModeProps, 'event'> {}

const MachineCell: FC<MachineCellProps> = ({ event, eventType, textConfig, C, font = initialFont }) => {
  const machineText = textConfig.machine?.[eventType]?.(event) ?? '';

  return <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>{machineText}</Text>;
};

export default React.memo(MachineCell, (prev, next) => {
  return prev.event.sequenceNumber === next.event.sequenceNumber && prev.eventType === next.eventType && prev.C.scheme === next.C.scheme;
});
